import React, { useState } from 'react'
import formatCurrency from '../Util/Util';
import { Link } from 'react-router-dom'


const CartModalList = ({ cart, increase, decrease, removeProduct }) => {
    const [modalCarts, setModalCarts] = useState(cart)

    const onRemoveFromCart = (productId) => {
        setModalCarts(cart => cart.filter(item => item._id !== productId))
        removeProduct(productId)
    }

    const totalItems = modalCarts.reduce((a, c) => a + c.count, 0);
    return (
        <>
            {modalCarts.length > 0 && (
                <div className="mini-cart shadow-bottom d-none d-lg-block ">
                    <div className="row p-0 m-0 d-flex col-12 align-items-center justify-content-between">
                        <div className="col-2">
                            <p className='my-3'>{totalItems} کالا</p>
                        </div>
                        <div className="col-7 d-flex justify-content-end">
                            <Link to='/cart' >
                                <button type="button" rel="tooltip" className="btn btn-warning p-2 border-0 mt-2" >
                                    <span className='fs14'>  برو به سبد خرید  </span>
                                    <i class="bi bi-cart-check-fill ps-3 h5"></i>
                                </button>
                            </Link>
                        </div>
                    </div>
                    
                    {
                        cart.map(product => (
                            <div className="row bg-white border p-2 m-2 rounded detail-box-cart " key={product._id} >

                                <div className="img-container col-lg-5">
                                    <img src={product.images[0]} className='img-fluid rounded  p-0 m-0' alt="" />
                                </div>
                                <div className="col-lg-7 text-black">
                                    <div className="pt-4 pt-lg-0 ">
                                        <h6 className='py-2 pt-4 lh-lg'>{product.fullName}</h6>
                                    </div>
                                    <div className="row d-flex col-12 align-items-center align-content-center h-auto p-0 m-0 ">
                                        <div className="col-4 amount d-flex justify-content-center align-items-center text-danger p-0 m-0 rounded px-3">
                                            <span className="count " onClick={() => increase(product._id)}>+</span>
                                            <span className='mx-2 border border-warning rounded-circle py-0 px-2 pt-1 '>{product.count}</span>
                                            <span className="count" onClick={() => decrease(product._id)}>-</span>
                                        </div>
                                        <p className='col-8 fs12 fw-bold text-danger d-flex align-items-center pt-3'>{formatCurrency(product.price)}</p>
                                    </div>
                                    <div className="delete-btn-box h5 col " onClick={() => onRemoveFromCart(product._id)}><i className="bi bi-x-circle "></i></div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            )}
        </>
    )
}

export default CartModalList